module.exports = __webpack_public_path__ + "static/media/AP_Normal_Z1.e8b92ff1.png";